module.exports = __webpack_public_path__ + "static/media/me3.2ea04b42.jpg";